/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ShareCollateralToken,
  ShareCollateralTokenInterface,
} from "../ShareCollateralToken";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string",
      },
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "MinimumShareRequirement",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlySilo",
    type: "error",
  },
  {
    inputs: [],
    name: "SenderNotSolventAfterTransfer",
    type: "error",
  },
  {
    inputs: [],
    name: "ShareTransferNotAllowed",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract INotificationReceiver",
        name: "notificationReceiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "success",
        type: "bool",
      },
    ],
    name: "NotificationSent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "MINIMUM_SHARE_AMOUNT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "asset",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "silo",
    outputs: [
      {
        internalType: "contract ISilo",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x60e06040523480156200001157600080fd5b50604051620015a4380380620015a4833981016040819052620000349162000283565b81818585816003908051906020019062000050929190620000f3565b50805162000066906004906020840190620000f3565b5050506001600160a01b03808316608052811660a08190526040805163313ce56760e01b8152905163313ce567916004808201926020929091908290030181865afa158015620000ba573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190620000e0919062000312565b60ff1660c052506200037a945050505050565b82805462000101906200033e565b90600052602060002090601f01602090048101928262000125576000855562000170565b82601f106200014057805160ff191683800117855562000170565b8280016001018555821562000170579182015b828111156200017057825182559160200191906001019062000153565b506200017e92915062000182565b5090565b5b808211156200017e576000815560010162000183565b634e487b7160e01b600052604160045260246000fd5b600082601f830112620001c157600080fd5b81516001600160401b0380821115620001de57620001de62000199565b604051601f8301601f19908116603f0116810190828211818310171562000209576200020962000199565b816040528381526020925086838588010111156200022657600080fd5b600091505b838210156200024a57858201830151818301840152908201906200022b565b838211156200025c5760008385830101525b9695505050505050565b80516001600160a01b03811681146200027e57600080fd5b919050565b600080600080608085870312156200029a57600080fd5b84516001600160401b0380821115620002b257600080fd5b620002c088838901620001af565b95506020870151915080821115620002d757600080fd5b50620002e687828801620001af565b935050620002f76040860162000266565b9150620003076060860162000266565b905092959194509250565b6000602082840312156200032557600080fd5b815160ff811681146200033757600080fd5b9392505050565b600181811c908216806200035357607f821691505b6020821081036200037457634e487b7160e01b600052602260045260246000fd5b50919050565b60805160a05160c0516111c9620003db60003960006101720152600081816101a10152610b640152600081816102b501528181610475015281816104db01528181610b9401528181610c5701528181610d6a0152610e0101526111c96000f3fe608060405234801561001057600080fd5b50600436106101005760003560e01c806340c10f1911610097578063a457c2d711610066578063a457c2d714610251578063a9059cbb14610264578063dd62ed3e14610277578063eb3beb29146102b057600080fd5b806340c10f19146101f857806370a082311461020d57806395d89b41146102365780639dc29fac1461023e57600080fd5b8063313ce567116100d3578063313ce5671461016b57806338d52e0f1461019c57806339509351146101db5780633ca4aed0146101ee57600080fd5b806306fdde0314610105578063095ea7b31461012357806318160ddd1461014657806323b872dd14610158575b600080fd5b61010d6102d7565b60405161011a9190610fab565b60405180910390f35b610136610131366004610ff6565b610369565b604051901515815260200161011a565b6002545b60405190815260200161011a565b610136610166366004611022565b61037f565b60405160ff7f000000000000000000000000000000000000000000000000000000000000000016815260200161011a565b6101c37f000000000000000000000000000000000000000000000000000000000000000081565b6040516001600160a01b03909116815260200161011a565b6101366101e9366004610ff6565b61042e565b61014a620186a081565b61020b610206366004610ff6565b61046a565b005b61014a61021b366004611063565b6001600160a01b031660009081526020819052604090205490565b61010d6104c1565b61020b61024c366004610ff6565b6104d0565b61013661025f366004610ff6565b610523565b610136610272366004610ff6565b6105bc565b61014a610285366004611080565b6001600160a01b03918216600090815260016020908152604080832093909416825291909152205490565b6101c37f000000000000000000000000000000000000000000000000000000000000000081565b6060600380546102e6906110b9565b80601f0160208091040260200160405190810160405280929190818152602001828054610312906110b9565b801561035f5780601f106103345761010080835404028352916020019161035f565b820191906000526020600020905b81548152906001019060200180831161034257829003601f168201915b5050505050905090565b60006103763384846105c9565b50600192915050565b600061038c8484846106ed565b6001600160a01b0384166000908152600160209081526040808320338452909152902054828110156104165760405162461bcd60e51b815260206004820152602860248201527f45524332303a207472616e7366657220616d6f756e74206578636565647320616044820152676c6c6f77616e636560c01b60648201526084015b60405180910390fd5b61042385338584036105c9565b506001949350505050565b3360008181526001602090815260408083206001600160a01b03871684529091528120549091610376918590610465908690611109565b6105c9565b336001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016146104b3576040516310528c6d60e11b815260040160405180910390fd5b6104bd82826108d2565b5050565b60606104cb6109c5565b905090565b336001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614610519576040516310528c6d60e11b815260040160405180910390fd5b6104bd82826109d4565b3360009081526001602090815260408083206001600160a01b0386168452909152812054828110156105a55760405162461bcd60e51b815260206004820152602560248201527f45524332303a2064656372656173656420616c6c6f77616e63652062656c6f77604482015264207a65726f60d81b606482015260840161040d565b6105b233858584036105c9565b5060019392505050565b60006103763384846106ed565b6001600160a01b03831661062b5760405162461bcd60e51b8152602060048201526024808201527f45524332303a20617070726f76652066726f6d20746865207a65726f206164646044820152637265737360e01b606482015260840161040d565b6001600160a01b03821661068c5760405162461bcd60e51b815260206004820152602260248201527f45524332303a20617070726f766520746f20746865207a65726f206164647265604482015261737360f01b606482015260840161040d565b6001600160a01b0383811660008181526001602090815260408083209487168084529482529182902085905590518481527f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925910160405180910390a3505050565b6001600160a01b0383166107515760405162461bcd60e51b815260206004820152602560248201527f45524332303a207472616e736665722066726f6d20746865207a65726f206164604482015264647265737360d81b606482015260840161040d565b6001600160a01b0382166107b35760405162461bcd60e51b815260206004820152602360248201527f45524332303a207472616e7366657220746f20746865207a65726f206164647260448201526265737360e81b606482015260840161040d565b6107be838383610b3a565b6001600160a01b038316600090815260208190526040902054818110156108365760405162461bcd60e51b815260206004820152602660248201527f45524332303a207472616e7366657220616d6f756e7420657863656564732062604482015265616c616e636560d01b606482015260840161040d565b6001600160a01b0380851660009081526020819052604080822085850390559185168152908120805484929061086d908490611109565b92505081905550826001600160a01b0316846001600160a01b03167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef846040516108b991815260200190565b60405180910390a36108cc848484610c1c565b50505050565b6001600160a01b0382166109285760405162461bcd60e51b815260206004820152601f60248201527f45524332303a206d696e7420746f20746865207a65726f206164647265737300604482015260640161040d565b61093460008383610b3a565b80600260008282546109469190611109565b90915550506001600160a01b03821660009081526020819052604081208054839290610973908490611109565b90915550506040518181526001600160a01b038316906000907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef9060200160405180910390a36104bd60008383610c1c565b6060600480546102e6906110b9565b6001600160a01b038216610a345760405162461bcd60e51b815260206004820152602160248201527f45524332303a206275726e2066726f6d20746865207a65726f206164647265736044820152607360f81b606482015260840161040d565b610a4082600083610b3a565b6001600160a01b03821660009081526020819052604090205481811015610ab45760405162461bcd60e51b815260206004820152602260248201527f45524332303a206275726e20616d6f756e7420657863656564732062616c616e604482015261636560f01b606482015260840161040d565b6001600160a01b0383166000908152602081905260408120838303905560028054849290610ae3908490611121565b90915550506040518281526000906001600160a01b038516907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef9060200160405180910390a3610b3583600084610c1c565b505050565b610b448383610ced565b610b4d57505050565b60405163a6e08aa160e01b81526001600160a01b037f00000000000000000000000000000000000000000000000000000000000000008116600483015283811660248301527f0000000000000000000000000000000000000000000000000000000000000000169063a6e08aa190604401602060405180830381865afa158015610bdb573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610bff9190611138565b610b35576040516349bb6ced60e11b815260040160405180910390fd5b610c27838383610d16565b610c318383610ced565b8015610cc457506040516338b51ce160e01b81526001600160a01b0384811660048301527f000000000000000000000000000000000000000000000000000000000000000016906338b51ce190602401602060405180830381865afa158015610c9e573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610cc29190611138565b155b15610ce257604051633c3b8e1b60e21b815260040160405180910390fd5b610b35838383610d66565b60006001600160a01b03831615801590610d0f57506001600160a01b03821615155b9392505050565b610d208383610ced565b15610d2a57505050565b6000610d3560025490565b90508015801590610d485750620186a081105b156108cc57604051637e442c1360e01b815260040160405180910390fd5b60007f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031663bde127186040518163ffffffff1660e01b8152600401602060405180830381865afa158015610dc6573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610dea919061115a565b604051631a16b46360e11b81526001600160a01b037f000000000000000000000000000000000000000000000000000000000000000081166004830152919091169063342d68c690602401602060405180830381865afa158015610e52573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610e76919061115a565b90506001600160a01b038116156108cc57604080513060248201526001600160a01b038681166044830152858116606483015260848083018690528351808403909101815260a490920183526020820180516001600160e01b0316630f1bf70d60e01b1790529151600092841691610eed91611177565b6000604051808303816000865af19150503d8060008114610f2a576040519150601f19603f3d011682016040523d82523d6000602084013e610f2f565b606091505b50509050816001600160a01b03167fe367d7de03229ee9a5f0a76a230fa0c93a7f8605b676469f7df108d5e813c07682604051610f70911515815260200190565b60405180910390a25050505050565b60005b83811015610f9a578181015183820152602001610f82565b838111156108cc5750506000910152565b6020815260008251806020840152610fca816040850160208701610f7f565b601f01601f19169190910160400192915050565b6001600160a01b0381168114610ff357600080fd5b50565b6000806040838503121561100957600080fd5b823561101481610fde565b946020939093013593505050565b60008060006060848603121561103757600080fd5b833561104281610fde565b9250602084013561105281610fde565b929592945050506040919091013590565b60006020828403121561107557600080fd5b8135610d0f81610fde565b6000806040838503121561109357600080fd5b823561109e81610fde565b915060208301356110ae81610fde565b809150509250929050565b600181811c908216806110cd57607f821691505b6020821081036110ed57634e487b7160e01b600052602260045260246000fd5b50919050565b634e487b7160e01b600052601160045260246000fd5b6000821982111561111c5761111c6110f3565b500190565b600082821015611133576111336110f3565b500390565b60006020828403121561114a57600080fd5b81518015158114610d0f57600080fd5b60006020828403121561116c57600080fd5b8151610d0f81610fde565b60008251611189818460208701610f7f565b919091019291505056fea26469706673582212203a35ec9c8f0b286c03acefa5e4c0413ce06042fc6882b978e32b58937f2f64f064736f6c634300080d0033";

type ShareCollateralTokenConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ShareCollateralTokenConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ShareCollateralToken__factory extends ContractFactory {
  constructor(...args: ShareCollateralTokenConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "ShareCollateralToken";
  }

  deploy(
    _name: string,
    _symbol: string,
    _silo: string,
    _asset: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ShareCollateralToken> {
    return super.deploy(
      _name,
      _symbol,
      _silo,
      _asset,
      overrides || {}
    ) as Promise<ShareCollateralToken>;
  }
  getDeployTransaction(
    _name: string,
    _symbol: string,
    _silo: string,
    _asset: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _name,
      _symbol,
      _silo,
      _asset,
      overrides || {}
    );
  }
  attach(address: string): ShareCollateralToken {
    return super.attach(address) as ShareCollateralToken;
  }
  connect(signer: Signer): ShareCollateralToken__factory {
    return super.connect(signer) as ShareCollateralToken__factory;
  }
  static readonly contractName: "ShareCollateralToken";
  public readonly contractName: "ShareCollateralToken";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ShareCollateralTokenInterface {
    return new utils.Interface(_abi) as ShareCollateralTokenInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ShareCollateralToken {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ShareCollateralToken;
  }
}
